import { render, staticRenderFns } from "./quantityPerTraderAndBrand.vue?vue&type=template&id=79aff04a&"
import script from "./quantityPerTraderAndBrand.vue?vue&type=script&lang=js&"
export * from "./quantityPerTraderAndBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports